

const tasksStore = {
    state: () => ({
        tasks: [],
        task: null
    }),
    actions: {},
    mutations: {
        getTasks: state => {
            state.tasks = taskExamples()
        },
        getTask: (state, taskId) => {},
        updateTask: (state, task) => {},
        deleteTask: (state, task) => {},

    },
    getters: {
        getTasks: state => {
            return state.tasks
        },
        getTask: state => {
            return state.task
        }
    }
}

export default tasksStore

const taskExamples = () => {
    let taskArray = []
    for (let i = 0; i < 11; i++) {
        let task = {
            id: i + 1,
            name: `Task ${i + 1}`,
            description: `Description for task number ${i + 1}`,
            completed: (i % 2 === 0)
        }
        taskArray.push(task)
    }
    return taskArray
}